import {
  PT_REPORTS_TABLE_HEADER,
  TABLEPAI,
  PT_REPORTS_SORT,
  PT_REPORTS_FILTERS,
} from "@/enums/pageEnum";
import MPTRCOM from "@/pages/report/components/MPTRCOM";

export default function MonthlyPassengerTrap() {
  return (
    <MPTRCOM
      tableHeader={PT_REPORTS_TABLE_HEADER}
      tableUrl={TABLEPAI.REP_PT_MONTH}
      reportSort={PT_REPORTS_SORT}
      reportFilter={PT_REPORTS_FILTERS}
      exportUrl="/api/reports/month-pt/export-excel"
    />
  );
}
